<template>
    <v-edit-dialog :return-value.sync="item.reply" large cancel-text="취소" save-text="저장" v-on="{ save }">
        <slot />
        <template #input>
            <v-sheet width="320" min-height="240">
                <v-textarea v-model="item.reply" hide-details rows="9" />
            </v-sheet>
        </template>
    </v-edit-dialog>
</template>

<script>
import { attrs_input } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        item: {},
        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.item = JSON.parse(JSON.stringify(this.value));
        },
        save() {
            let { _id, reply } = this.item;
            let form = { _id, reply };

            this.$emit("update", form);
        },
    },
};
</script>

